import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function PasswordCard() {
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleToggleRetypePasswordVisibility = () => {
    setShowRetypePassword(!showRetypePassword);
  };

  return (
    <div className=" container pt-3 pb-5">
      <div className="content-wrapper">
        <div className="title delete-title">
          <h1><span className="orange-box"></span> Change Password</h1>
        </div>

        <div className="card delete-card">
          <h3>Change Password</h3>

          <p>Old Password</p>
          {/* Input field for entering old password */}
          <TextField
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter your password"
            className="password-input"
            variant="outlined"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePasswordVisibility}>
                    {showPassword ? <Visibility /> :  <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <p>New Password</p>
          {/* Input field for entering new password */}
          <TextField
            type={showNewPassword ? 'text' : 'password'}
            placeholder="Enter your new password"
            className="password-input"
            variant="outlined"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggleNewPasswordVisibility}>
                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <p>Retype New Password</p>
          {/* Input field for retyping new password */}
          <TextField
            type={showRetypePassword ? 'text' : 'password'}
            placeholder="Retype your new password"
            className="password-input"
            // variant="outlined"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggleRetypePasswordVisibility}>
                    {showRetypePassword ? <Visibility /> :  <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          {/* Button for changing the password */}
          <button className="delete-button Password-button">Change Password</button>
        </div>
      </div>
    </div>
  );
}

export default PasswordCard;
